import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServerLinks } from '@shared/services/server-links';
import { ServerLinkName } from '@shared/models/server-links-model';
import { NearestResponse } from '@shared/components/map/models/address.service';
import { SnackBarService } from '@shared/components/snackbar-message/services/snackbar.service';
import { MirSnackbarType } from '@shared/components/snackbar-message/model/snackbar';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private _openDataLink: string;
  public readonly key = '42ad45ce-016d-11eb-9d17-f321695485f2';
  constructor(private http: HttpClient, private serverLinks: ServerLinks, private snackBar: SnackBarService) {
    this._openDataLink = serverLinks.getLink(ServerLinkName.OpenData);
  }

  private showSnackBar(errorMessage: string): void {
    this.snackBar.open(MirSnackbarType.Error, [
      {
        translate: true,
        message: 'SNACK_BAR_MESSAGE.ERROR_REQUESTING_GET_LANDMARK'
      },
      {
        translate: false,
        message: errorMessage
      }
    ]);
  }

  public getLocationByCoords(lon: number, lat: number): Observable<NearestResponse | null> {
    return this.http
      .post<NearestResponse>(`${this._openDataLink}address/nearest`, {
        long: +lon.toFixed(6),
        lat: +lat.toFixed(6),
        radius: 250,
        limit: 1
      })
      .pipe(
        map(response => {
          if (response.data && response.status === 'success') {
            return response;
          }
          this.showSnackBar(response.message);
          return null;
        }),
        catchError((error: HttpErrorResponse) => {
          this.showSnackBar(error.message);
          return throwError(() => error);
        })
      );
  }
}
